import { createContext, useContext } from 'react'

const InitialMapSplashContext = createContext<(() => void) | null>(null)

export const InitialMapSplashProvider = InitialMapSplashContext.Provider

export function useDismissInitialMapSplash() {
  return useContext(InitialMapSplashContext) ?? (() => undefined)
}
